import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import { AuthGuard } from "./features/auth/components/AuthGuard";
import LoginPage2 from "./features/auth/pages/LoginPage2";
import { MessagingTerms } from "./features/auth/pages/MessagingTerms";
import { ResetPasswordPage } from "./features/auth/pages/ResetPasswordPage";
import { TermsPage } from "./features/auth/pages/TermsPage";
import { Appointments } from "./features/mentee/pages/Appointments";
import { ChatAgent } from "./features/mentee/pages/ChatAgent";
import { Insights } from "./features/mentee/pages/Insights";
import { MentorDetailPage } from "./features/mentee/pages/MentorDetail";
import { MentorsPage } from "./features/mentee/pages/Mentors";
import { MentorStatic } from "./features/mentee/pages/MentorStatic";
import { Resources } from "./features/mentee/pages/Resources";
import { Session } from "./features/mentee/pages/Session";
import { VideoCall } from "./features/mentee/pages/VideoCall";
import EmptyLayout from "./layouts/empty-layout";
import MainLayout from "./layouts/main-layout";

function App() {
  return (
    <div className="min-h-screen">
      <Routes>
        {/* Public routes */}
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/messaging-terms" element={<MessagingTerms />} />
        <Route path="/auth/login" element={<LoginPage2 />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        {/* Protected routes wrapper */}
        <Route element={<AuthGuard />}>
          {/* Default redirect */}
          <Route index element={<Navigate to="/mentee/chat" replace />} />

          {/* Mentee routes with Layout */}
          <Route
            element={
              <MainLayout>
                <Outlet />
              </MainLayout>
            }
          >
            <Route path="mentee">
              <Route index element={<Navigate to="/mentee/chat" replace />} />
              <Route path="chat" element={<ChatAgent />} />
              <Route path="appointments" element={<Appointments />} />
              <Route path="mentor" element={<MentorStatic />} />
              <Route path="mentors" element={<MentorsPage />} />
              <Route path="mentors/:mentorId" element={<MentorDetailPage />} />
              <Route path="session" element={<Session />} />
              <Route path="insights" element={<Insights />} />
              <Route path="resources" element={<Resources />} />
            </Route>
          </Route>
        </Route>

        <Route
          element={
            <EmptyLayout>
              <Outlet />
            </EmptyLayout>
          }
        >
          <Route path="mentee">
            <Route path="video-call" element={<VideoCall />} />
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
